import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import { TableRow, TableRowColumn } from 'material-ui';
import DwtGroup from './RowData/DwtGroup';
import Imo from './RowData/Imo';
import IndexSelector from './RowData/IndexSelector';
import FromTo from './RowData/FromTo';
import TypesGeneral from './RowData/TypeGeneral';
import VesselType from './RowData/VesselType';
import styles from './styles';
import RoundClean from './RowData/RoundClean';
import LayCan from './RowData/LayCan';
import Duration from './RowData/Durations';
import BalastBonus from './RowData/BalastBonus';
import Intake from './RowData/Intake';
import TcIndexValue from './RowData/TcIndexValue';
import { ChangeFieldsContext, HandleUpdateErrorsContext } from './TcIndexPage';
import { Approve, Reject, Remove } from './RowData/ManageButtons';
import Via from './RowData/Via';

const s = {
    small: { ...styles.tableRowSm },
    normal: { ...styles.tableRow },
};

export default function TcIndexRow({ hireData, countIndex, errors: _errors }) {
    const changeFieldsMultiple = useContext(ChangeFieldsContext);
    const handleUpdateErrors = useContext(HandleUpdateErrorsContext);
    const [errors, setErrors] = useState(_errors);

    useEffect(() => {
        setErrors(_errors[countIndex]);
    }, [_errors]);

    const handleErrors = (field, value) => {
        handleUpdateErrors(countIndex, field, value);
    };

    return (
        <React.Fragment>
            <TableRow >
                <TableRowColumn style={{ ...s.small }}>
                    <IndexSelector
                        hireData={hireData}
                        changeFieldsMultiple={changeFieldsMultiple}
                        countIndex={countIndex}
                    />
                </TableRowColumn>
                <TableRowColumn style={{ ...s.small }}>
                    <Imo
                        imo={hireData.vessel ? hireData.vessel.imoNumber : null}
                        changeFieldsMultiple={changeFieldsMultiple}
                        countIndex={countIndex}
                    />
                </TableRowColumn>
                <TableRowColumn style={{ ...s.small, ...(errors && errors.typeGeneral ? styles.error : {}) }}>
                    <TypesGeneral 
                        typeGeneral={hireData.typeByPurpose}
                        changeFieldsMultiple={changeFieldsMultiple}
                        countIndex={countIndex}
                        required
                        setHasErrors={handleErrors}
                    />
                </TableRowColumn>
                <TableRowColumn 
                    style={{ 
                        ...s.small, 
                        ...(errors && errors.vesselDwtGroup ? styles.error : {}), 
                        backgroundColor: hireData.typeByPurpose ? 'inherit' : '#eaeaea',
                    }}
                >
                    <VesselType 
                        vesselType={hireData.vesselDwtGroup}
                        currentTypeGeneral={hireData.typeByPurpose}
                        changeFieldsMultiple={changeFieldsMultiple}
                        countIndex={countIndex}
                        required
                        setHasErrors={handleErrors}
                        disabled={!hireData.typeByPurpose}
                    />
                </TableRowColumn> 
                <TableRowColumn style={{ 
                    ...s.small, 
                    ...(errors && errors.vesselDwtGroup ? styles.error : {}),
                    backgroundColor: hireData.typeByPurpose ? 'inherit' : '#eaeaea',
                }}
                >
                    <DwtGroup 
                        vesselType={hireData.vesselDwtGroup}
                        currentTypeGeneral={hireData.typeByPurpose}
                        changeFieldsMultiple={changeFieldsMultiple}
                        countIndex={countIndex}
                        required
                        setHasErrors={handleErrors}
                        disabled={!hireData.typeByPurpose}
                    />
                </TableRowColumn>
                <TableRowColumn style={{ ...s.normal }}>
                    <FromTo 
                        field='placeFrom'
                        data={hireData.placeFrom}
                        changeFieldsMultiple={changeFieldsMultiple}
                        countIndex={countIndex}
                        mainRegions={false}
                        withAreas={false}
                    />
                </TableRowColumn>
                <TableRowColumn style={{ ...s.normal, ...(errors && errors.regionFrom ? styles.error : {}) }}>
                    <FromTo 
                        field='regionFrom'
                        data={hireData.regionFrom}
                        changeFieldsMultiple={changeFieldsMultiple}
                        countIndex={countIndex}
                        required
                        setHasErrors={handleErrors}
                        mainRegions
                        withAreas
                        isInBalticIndex
                        onlyAreas
                    />
                </TableRowColumn>
                <TableRowColumn style={{ ...s.normal }}>
                    <FromTo 
                        field='placeTo'
                        data={hireData.placeTo}
                        changeFieldsMultiple={changeFieldsMultiple}
                        countIndex={countIndex}
                        mainRegions={false}
                        withAreas={false}
                    />
                </TableRowColumn>
                <TableRowColumn style={{ ...s.normal, ...(errors && errors.regionTo ? styles.error : {}) }}>
                    <FromTo 
                        field='regionTo'
                        data={hireData.regionTo}
                        changeFieldsMultiple={changeFieldsMultiple}
                        countIndex={countIndex}
                        required
                        setHasErrors={handleErrors}
                        mainRegions
                        withAreas
                        onlyAreas
                        isInBalticIndex
                    />
                </TableRowColumn>
                <TableRowColumn style={{ ...s.normal }}>
                    <Via 
                        via={hireData.via}
                        changeFieldsMultiple={changeFieldsMultiple}
                        countIndex={countIndex}
                    />
                </TableRowColumn>
                <TableRowColumn style={{ ...s.small, textAlign: 'center' }}>
                    <RoundClean 
                        checked={hireData.roundTrip}
                        field='roundTrip'
                        countIndex={countIndex}
                        changeFieldsMultiple={changeFieldsMultiple}
                    />
                </TableRowColumn>
                <TableRowColumn style={{ ...s.small, textAlign: 'center' }}>
                    <RoundClean 
                        checked={hireData.clean}
                        field='clean'
                        countIndex={countIndex}
                        changeFieldsMultiple={changeFieldsMultiple}
                    />
                </TableRowColumn>
                <TableRowColumn style={{ ...s.normal, ...(errors && errors.layCan ? styles.error : {}) }}>
                    <LayCan 
                        lay={hireData.lay}
                        can={hireData.can}
                        required
                        setHasErrors={handleErrors}
                        countIndex={countIndex}
                        changeFieldsMultiple={changeFieldsMultiple}
                    />
                </TableRowColumn>
                <TableRowColumn style={{ ...s.small }}>
                    <Duration 
                        duration={hireData.duration}
                        changeFieldsMultiple={changeFieldsMultiple}
                        countIndex={countIndex}
                    />
                </TableRowColumn>
                <TableRowColumn style={{ ...s.small }}>
                    <BalastBonus 
                        balastBonus={hireData.balastBonus}
                        changeFieldsMultiple={changeFieldsMultiple}
                        countIndex={countIndex}
                    />
                </TableRowColumn>
                <TableRowColumn style={{ ...s.small }}>
                    <Intake 
                        intake={hireData.intake}
                        changeFieldsMultiple={changeFieldsMultiple}
                        countIndex={countIndex}
                    />
                </TableRowColumn>
                <TableRowColumn style={{ ...s.small, ...(errors && errors.tcIndex ? styles.error : {}) }}>
                    <TcIndexValue 
                        tcIndex={hireData.tcIndex}
                        required
                        setHasErrors={handleErrors}
                        changeFieldsMultiple={changeFieldsMultiple}
                        countIndex={countIndex}
                    />
                </TableRowColumn>
                <TableRowColumn style={{ ...s.normal }}>
                    {
                        hireData.lastUpdate && <div style={{ fontSize: '9px', textOverflow: 'ellipsis' }}>
                            {hireData.lastUpdate.user.email}<br />
                            {hireData.lastUpdate.user.company.name}<br />
                            {moment(hireData.lastUpdate.date).format('DD MM YYYY hh:mm:ss')}<br />
                        </div>

                    }
                </TableRowColumn>
                <TableRowColumn style={{ ...s.small, textOverflow: 'unset' }}>
                    <Approve
                        confirmed={hireData.confirmed}
                        hireDataId={hireData._id}
                        changeFieldsMultiple={changeFieldsMultiple}
                        countIndex={countIndex}
                    />
                </TableRowColumn>
                <TableRowColumn style={{ ...s.small, textOverflow: 'unset' }}>
                    <Reject 
                        rejected={hireData.rejected}
                        changeFieldsMultiple={changeFieldsMultiple}
                        hireDataId={hireData._id || hireData.unique_id}
                        countIndex={countIndex}
                    />
                </TableRowColumn>
                <TableRowColumn style={{ ...s.small, borderRight: styles.borderRight, textOverflow: 'unset' }}>
                    <Remove 
                        hireDataId={hireData._id || hireData.unique_id}
                        changeFieldsMultiple={changeFieldsMultiple}
                        countIndex={countIndex}
                    />
                </TableRowColumn>
            </TableRow>
        </React.Fragment>
    );
}



// WEBPACK FOOTER //
// ./app/components/TcIndex/TcIndexRow.jsx